import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InsightsState } from 'app-redux/InsightsState';
import * as dto from 'client/dto';
import { nameof } from 'utils/typeHelpers';

export type DiseasesState = {
  isLoading: boolean;
  hasError: boolean;
  /** TODO: This should be updated to be named allRelevant/UserDiseaseIds */
  allDiseaseIds: number[];
  diseaseInformationByDiseaseId: Record<number, dto.DiseaseInformationModel>;
  diseaseGroups: dto.DiseaseGroupModel[];
  allAvailableDiseases: dto.DiseaseInformationModel[];
};

export const InitialDiseasesState: DiseasesState = {
  isLoading: false,
  hasError: false,
  allDiseaseIds: [],
  diseaseInformationByDiseaseId: {},
  diseaseGroups: [],
  allAvailableDiseases: [],
};

const diseasesSlice = createSlice({
  name: nameof<InsightsState>('diseases'),
  initialState: InitialDiseasesState,
  reducers: {
    loadAllDiseasesStart: state => {
      state.isLoading = true;
    },
    loadAllDiseasesError: state => {
      state.isLoading = false;
      state.hasError = true;
    },
    loadAllDiseasesSuccess: (state, action: PayloadAction<dto.DiseaseInformationModel[]>) => {
      state.isLoading = false;
      state.diseaseInformationByDiseaseId = {};
      state.allDiseaseIds = [];
      const diseaseInformations = action.payload;
      diseaseInformations.forEach(diseaseInformation => {
        const diseaseId = diseaseInformation.id;
        state.allDiseaseIds.push(diseaseId);
        state.diseaseInformationByDiseaseId[diseaseInformation.id] = diseaseInformation;
      });
    },
    loadDiseaseInfoSuccess: (state, action: PayloadAction<dto.DiseaseInformationModel>) => {
      const diseaseInformation = action.payload;

      if (!state.allDiseaseIds.includes(diseaseInformation.id))
        state.allDiseaseIds.push(diseaseInformation.id);

      state.diseaseInformationByDiseaseId[diseaseInformation.id] = diseaseInformation;
    },
    loadDiseaseInfoError: state => {
      state.hasError = true;
    },
    loadAvailableDiseasesSuccess: (state, action: PayloadAction<dto.DiseaseInformationModel[]>) => {
      state.allAvailableDiseases = action.payload;
      state.isLoading = false;
    },
    loadDiseaseGroupsSuccess: (state, action: PayloadAction<dto.DiseaseGroupModel[]>) => {
      state.diseaseGroups = action.payload;
      state.isLoading = false;
    },
  },
});

const { actions, reducer } = diseasesSlice;
export const {
  loadAllDiseasesStart,
  loadAllDiseasesError,
  loadAllDiseasesSuccess,
  loadDiseaseInfoSuccess,
  loadDiseaseInfoError,
  loadAvailableDiseasesSuccess,
  loadDiseaseGroupsSuccess,
} = actions;
export default reducer;
